function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, createContext, useMemo, useContext, useCallback } from 'react';

function useLoadGsiScript() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nonce = options.nonce,
      onScriptLoadSuccess = options.onScriptLoadSuccess,
      onScriptLoadError = options.onScriptLoadError;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      scriptLoadedSuccessfully = _useState2[0],
      setScriptLoadedSuccessfully = _useState2[1];

  var onScriptLoadSuccessRef = useRef(onScriptLoadSuccess);
  onScriptLoadSuccessRef.current = onScriptLoadSuccess;
  var onScriptLoadErrorRef = useRef(onScriptLoadError);
  onScriptLoadErrorRef.current = onScriptLoadError;
  useEffect(function () {
    var scriptTag = document.createElement('script');
    scriptTag.src = 'https://accounts.google.com/gsi/client';
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.nonce = nonce;

    scriptTag.onload = function () {
      var _a;

      setScriptLoadedSuccessfully(true);
      (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadSuccessRef);
    };

    scriptTag.onerror = function () {
      var _a;

      setScriptLoadedSuccessfully(false);
      (_a = onScriptLoadErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadErrorRef);
    };

    document.body.appendChild(scriptTag);
    return function () {
      document.body.removeChild(scriptTag);
    };
  }, [nonce]);
  return scriptLoadedSuccessfully;
}

var GoogleOAuthContext = /*#__PURE__*/createContext(null);

function GoogleOAuthProvider(_ref) {
  var clientId = _ref.clientId,
      nonce = _ref.nonce,
      onScriptLoadSuccess = _ref.onScriptLoadSuccess,
      onScriptLoadError = _ref.onScriptLoadError,
      children = _ref.children;
  var scriptLoadedSuccessfully = useLoadGsiScript({
    nonce: nonce,
    onScriptLoadSuccess: onScriptLoadSuccess,
    onScriptLoadError: onScriptLoadError
  });
  var contextValue = useMemo(function () {
    return {
      clientId: clientId,
      scriptLoadedSuccessfully: scriptLoadedSuccessfully
    };
  }, [clientId, scriptLoadedSuccessfully]);
  return /*#__PURE__*/React.createElement(GoogleOAuthContext.Provider, {
    value: contextValue
  }, children);
}

function useGoogleOAuth() {
  var context = useContext(GoogleOAuthContext);

  if (!context) {
    throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
  }

  return context;
}

function extractClientId(credentialResponse) {
  var _a;

  var clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
  return clientId;
}

var containerHeightMap = {
  large: 40,
  medium: 32,
  small: 20
};

function GoogleLogin(_ref2) {
  var onSuccess = _ref2.onSuccess,
      onError = _ref2.onError,
      useOneTap = _ref2.useOneTap,
      promptMomentNotification = _ref2.promptMomentNotification,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'standard' : _ref2$type,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'outline' : _ref2$theme,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'large' : _ref2$size,
      text = _ref2.text,
      shape = _ref2.shape,
      logo_alignment = _ref2.logo_alignment,
      width = _ref2.width,
      locale = _ref2.locale,
      click_listener = _ref2.click_listener,
      containerProps = _ref2.containerProps,
      props = _objectWithoutProperties(_ref2, ["onSuccess", "onError", "useOneTap", "promptMomentNotification", "type", "theme", "size", "text", "shape", "logo_alignment", "width", "locale", "click_listener", "containerProps"]);

  var btnContainerRef = useRef(null);

  var _useGoogleOAuth = useGoogleOAuth(),
      clientId = _useGoogleOAuth.clientId,
      scriptLoadedSuccessfully = _useGoogleOAuth.scriptLoadedSuccessfully;

  var onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;
  var onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  var promptMomentNotificationRef = useRef(promptMomentNotification);
  promptMomentNotificationRef.current = promptMomentNotification;
  useEffect(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;

    if (!scriptLoadedSuccessfully) return;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.initialize(_objectSpread({
      client_id: clientId,
      callback: function callback(credentialResponse) {
        var _a;

        if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
          return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
        }

        var credential = credentialResponse.credential,
            select_by = credentialResponse.select_by;
        onSuccessRef.current({
          credential: credential,
          clientId: extractClientId(credentialResponse),
          select_by: select_by
        });
      }
    }, props));
    (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.renderButton(btnContainerRef.current, {
      type: type,
      theme: theme,
      size: size,
      text: text,
      shape: shape,
      logo_alignment: logo_alignment,
      width: width,
      locale: locale,
      click_listener: click_listener
    });
    if (useOneTap) (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
    return function () {
      var _a, _b, _c;

      if (useOneTap) (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, scriptLoadedSuccessfully, useOneTap, type, theme, size, text, shape, logo_alignment, width, locale]);
  return /*#__PURE__*/React.createElement("div", _objectSpread(_objectSpread({}, containerProps), {}, {
    ref: btnContainerRef,
    style: _objectSpread({
      height: containerHeightMap[size]
    }, containerProps === null || containerProps === void 0 ? void 0 : containerProps.style)
  }));
}

function googleLogout() {
  var _a, _b, _c;

  (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.disableAutoSelect();
}
/* eslint-disable import/export */


function useGoogleLogin(_ref3) {
  var _ref3$flow = _ref3.flow,
      flow = _ref3$flow === void 0 ? 'implicit' : _ref3$flow,
      _ref3$scope = _ref3.scope,
      scope = _ref3$scope === void 0 ? '' : _ref3$scope,
      onSuccess = _ref3.onSuccess,
      onError = _ref3.onError,
      onNonOAuthError = _ref3.onNonOAuthError,
      overrideScope = _ref3.overrideScope,
      state = _ref3.state,
      props = _objectWithoutProperties(_ref3, ["flow", "scope", "onSuccess", "onError", "onNonOAuthError", "overrideScope", "state"]);

  var _useGoogleOAuth2 = useGoogleOAuth(),
      clientId = _useGoogleOAuth2.clientId,
      scriptLoadedSuccessfully = _useGoogleOAuth2.scriptLoadedSuccessfully;

  var clientRef = useRef();
  var onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;
  var onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  var onNonOAuthErrorRef = useRef(onNonOAuthError);
  onNonOAuthErrorRef.current = onNonOAuthError;
  useEffect(function () {
    var _a;

    if (!scriptLoadedSuccessfully) return;
    var clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
    var client = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts.oauth2[clientMethod](_objectSpread({
      client_id: clientId,
      scope: overrideScope ? scope : "openid profile email ".concat(scope),
      callback: function callback(response) {
        var _a, _b;

        if (response.error) return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
        (_b = onSuccessRef.current) === null || _b === void 0 ? void 0 : _b.call(onSuccessRef, response);
      },
      error_callback: function error_callback(nonOAuthError) {
        var _a;

        (_a = onNonOAuthErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onNonOAuthErrorRef, nonOAuthError);
      },
      state: state
    }, props));
    clientRef.current = client; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, scriptLoadedSuccessfully, flow, scope, state]);
  var loginImplicitFlow = useCallback(function (overrideConfig) {
    var _a;

    return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig);
  }, []);
  var loginAuthCodeFlow = useCallback(function () {
    var _a;

    return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode();
  }, []);
  return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}

function useGoogleOneTapLogin(_ref4) {
  var onSuccess = _ref4.onSuccess,
      onError = _ref4.onError,
      promptMomentNotification = _ref4.promptMomentNotification,
      cancel_on_tap_outside = _ref4.cancel_on_tap_outside,
      prompt_parent_id = _ref4.prompt_parent_id,
      state_cookie_domain = _ref4.state_cookie_domain,
      hosted_domain = _ref4.hosted_domain,
      disabled = _ref4.disabled;

  var _useGoogleOAuth3 = useGoogleOAuth(),
      clientId = _useGoogleOAuth3.clientId,
      scriptLoadedSuccessfully = _useGoogleOAuth3.scriptLoadedSuccessfully;

  var onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;
  var onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  var promptMomentNotificationRef = useRef(promptMomentNotification);
  promptMomentNotificationRef.current = promptMomentNotification;
  useEffect(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;

    if (!scriptLoadedSuccessfully) return;

    if (disabled) {
      (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
      return;
    }

    (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.initialize({
      client_id: clientId,
      callback: function callback(credentialResponse) {
        var _a;

        if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
          return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
        }

        var credential = credentialResponse.credential,
            select_by = credentialResponse.select_by;
        onSuccessRef.current({
          credential: credential,
          clientId: extractClientId(credentialResponse),
          select_by: select_by
        });
      },
      hosted_domain: hosted_domain,
      cancel_on_tap_outside: cancel_on_tap_outside,
      prompt_parent_id: prompt_parent_id,
      state_cookie_domain: state_cookie_domain
    });
    (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
    return function () {
      var _a, _b, _c;

      (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
    };
  }, [clientId, scriptLoadedSuccessfully, cancel_on_tap_outside, prompt_parent_id, state_cookie_domain, hosted_domain, disabled]);
}
/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */


function hasGrantedAllScopesGoogle(tokenResponse, firstScope) {
  var _c2;

  var _a, _b, _c;

  if (!(window === null || window === void 0 ? void 0 : window.google)) return false;

  for (var _len = arguments.length, restScopes = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    restScopes[_key - 2] = arguments[_key];
  }

  return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : (_c2 = _c).hasGrantedAllScopes.apply(_c2, [tokenResponse, firstScope].concat(restScopes))) || false;
}
/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */


function hasGrantedAnyScopeGoogle(tokenResponse, firstScope) {
  var _c3;

  var _a, _b, _c;

  if (!(window === null || window === void 0 ? void 0 : window.google)) return false;

  for (var _len2 = arguments.length, restScopes = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    restScopes[_key2 - 2] = arguments[_key2];
  }

  return ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : (_c3 = _c).hasGrantedAnyScope.apply(_c3, [tokenResponse, firstScope].concat(restScopes))) || false;
}

export { GoogleLogin, GoogleOAuthProvider, googleLogout, hasGrantedAllScopesGoogle, hasGrantedAnyScopeGoogle, useGoogleLogin, useGoogleOneTapLogin };